var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-containeradder-item-wrapper",
    },
    [
      _c("span", {
        staticClass: "cw-sortable-handle cw-sortable-handle-containeradder",
      }),
      _vm._v(" "),
      _c(
        "a",
        {
          attrs: {
            href: "#",
          },
          on: {
            click: function click($event) {
              $event.preventDefault()
              return _vm.addNewContainer.apply(null, arguments)
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "cw-containeradder-item",
              class: ["cw-containeradder-item-" + _vm.type],
            },
            [
              _c(
                "header",
                {
                  staticClass: "cw-containeradder-item-title",
                },
                [
                  _vm._v(
                    "\n                " + _vm._s(_vm.title) + "\n            "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  staticClass: "cw-containeradder-item-description",
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.description) +
                      "\n            "
                  ),
                ]
              ),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "li",
        {
          ref: "container-drag-item",
          staticClass: "cw-container-dragitem cw-container-item-sortable",
        },
        [
          _c(
            "div",
            {
              staticClass: "cw-container cw-container-list cw-container-item",
              class: ["cw-container-colspan-" + _vm.colspan],
            },
            [
              _c(
                "div",
                {
                  staticClass: "cw-container-content",
                },
                [
                  _c(
                    "header",
                    {
                      staticClass: "cw-container-header",
                    },
                    [_vm._v(_vm._s(_vm.title))]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "cw-block-wrapper",
                    },
                    [_vm._v(_vm._s(_vm.description))]
                  ),
                ]
              ),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }